(() => {
  function initLpEffects() {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    // フェード：画面下端から80px内側で表示
    if ("IntersectionObserver" in window && !reducedMotion) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.remove("lp-fade-pending");
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: "0px 0px -80px 0px",
        threshold: 0
      });

      document.querySelectorAll(".lp-fade").forEach((element) => {
        if (element.dataset.lpFadeReady) return;

        element.dataset.lpFadeReady = "true";
        element.classList.add("lp-fade-pending");
        observer.observe(element);
      });
    }

    // Swiper：対象の画像枠ごとに起動
    if (typeof window.Swiper === "function") {
      document.querySelectorAll(".lp-swiper").forEach((element) => {
        if (element.swiper) return;

        const slides = element.querySelectorAll(
          ".swiper-wrapper > .swiper-slide"
        );
        if (slides.length < 2) return;

        new window.Swiper(element, {
          slidesPerView: 1,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          loop: true,
          speed: reducedMotion ? 0 : 800,
          autoplay: reducedMotion ? false : {
            delay: 3000,
            disableOnInteraction: false
          }
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLpEffects, {
      once: true
    });
  } else {
    initLpEffects();
  }
})();
